export const getQuizType = (type) => {
  if (type === "multipleChoice") {
    return "تستی";
  } else if (type === "multipleImageChoice") {
    return "تصویری";
  } else if (type === "range") {
    return "طیفی";
  } else if (type === "puzzle") {
    return "پازل";
  } else if (type === "sorting") {
    return "مرتب کردن";
  } else if (type === "difference") {
    return "کشف تفاوت";
  } else if (type === "connecting") {
    return "وصل کردن";
  } else if (type === "file") {
    return "ارسال فایل";
  }
};
